export default __webpack_public_path__ + "static/media/theme-chooser.a4a7b780.png";